// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const AttackBlockIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="AttackBlockIcon" ref={forwardedRef} {...props}>
      <path d="m15.47 11.813 1.719-2.526a1.64 1.64 0 0 0 .296-.938A1.64 1.64 0 0 0 17.19 7.41l-5.37-5.467A3.8 3.8 0 0 0 10.04 1.5a3.8 3.8 0 0 0-1.782.443L2.88 7.41a1.87 1.87 0 0 0-.254.94A1.87 1.87 0 0 0 2.88 9.287l1.746 2.616C3.784 12.001 3.186 12.398 2.624 13a3.2 3.2 0 0 0-.874 2.183V18.4h7.134l1.5-1.5H3.317v-2.28c0-.535 1.111-1.842 3.496-1.842L4.428 8.854C4.341 8.618 4.218 8.285 4.82 7.662c.66-.684 3.001-3.19 4.125-4.396.298-.32 1.852-.366 2.182 0 .82.908 2.865 3.09 4.092 4.396.5.532.573 1.007.326 1.364l-1.276 2.128.93.93z" />
      <path d="M8.436 12.838a3 3 0 0 1-1.193-.818 3.3 3.3 0 0 1-.634-1.076 3.6 3.6 0 0 1-.212-1.261L6.394 6.298a22 22 0 0 1 7.212 0v3.385a3.7 3.7 0 0 1-.076.732L12.194 9.08l-.069.069V7.613a13 13 0 0 0-4.25 0l.001 1.995a2.1 2.1 0 0 0 .125.743 2 2 0 0 0 .374.634 1.75 1.75 0 0 0 .566.425 1.6 1.6 0 0 0 .67.153h.1z" />
      <path d="m15.09 16.3 2.983 2.983 1.108-1.011-3.03-3.031 2.978-2.98-1.107-1.011-2.931 2.931-2.932-2.931-1.107 1.012 2.979 2.979L11 18.27l1.108 1.012z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const AttackBlockIcon = /* @__PURE__ */ Object.assign(
  AttackBlockIconComponent,
  { displayName: 'AttackBlockIcon' },
);
